export { SecuritiesPage as default } from '@/components/pages/Ir/Library/Securities'
